<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="bitacoras"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bitacora</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  @click="init()"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Mostrar solo las de este día</span>
            </v-tooltip>
            <v-col cols="auto" md="3">
              <v-text-field
                class="text-xs-center ml-5"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" md="2" class="mr-4">
              <v-text-field
                v-model="fechaDesde"
                type="date"
                hide-details
                label="Desde fecha de creación"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="auto" md="2" class="mr-4">
              <v-text-field
                v-model="fechaHasta"
                type="date"
                hide-details
                label="Hasta fecha de creación"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn @click="listar()" color="blue" dark>
                Listar
              </v-btn>
            </v-col>

            <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="numeroAsistencia"
                          label="NUMERO DE ASISTENCIA"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="operador"
                          label="OPERADOR"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="fechaHoraActual"
                          label="FECHA APERTURA"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field
                          v-model="comDireccionSiniestro"
                          label="DIRECCION"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="tipoServicio"
                          label="TIPO SERVICIO"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="proveedor"
                          label="PROVEEDOR ASIGNADO"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="atiende"
                          label="Valuo por daños"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="fechaHoraAsignacion"
                          label="FECHA ASIGNACION"
                          disabled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <div>
                          <h2>Caracteres actuales: {{ caracteresDisponibles }} de 5,000 disponibles</h2>
                        </div>
                      </v-col>
                      <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                      <v-col cols="12" v-for="(item, i) in dataSplit" :key="i">
                        <v-textarea
                          v-model="item.seguimiento"
                          label="SEGUIMIENTO"
                          :disabled="item.disabled"
                          auto-grow
                          @keyup.enter="asignarfecha(i)"
                          hint="PRESIONE ENTER PARA ASIGNAR FECHA Y SU NOMBRE"
                          persistent-hint
                          outlined
                        ></v-textarea>
                      </v-col>
                      <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
                      <v-btn
                        color="primary"
                        class="my-auto"
                        @click="agregarCampo()"
                      >
                        Agregar Seguimiento
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close" dark color="grey">CANCELAR</v-btn>
                  <v-btn
                    color="success"
                    :disabled="disabledActualizarBitacora"
                    @click="guardar"
                    >GUARDAR</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            edit
          </v-icon>
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px;"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar
        v-model="snackFechas"
        color="cyan darken-2"
        top
        right
        :timeout="3000"
        >Debe de seleccionar ambas fechas.</v-snackbar
      >

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >Sucedio algun error, verificar estado de conexión.</v-snackbar
      >
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      bitacoras: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Operador", value: "operador", sortable: true },
        {
          text: "Fecha Hora Actual",
          value: "fechaHoraActual",
          sortable: true,
        },
        {
          text: "Direccion Siniestro",
          value: "comDireccionSiniestro",
          sortable: true,
        },
        { text: "Tipo Servicio", value: "tipoServicio", sortable: true },
        { text: "Proveedor", value: "proveedor", sortable: true },
        { text: "Seguimiento", value: "seguimiento", sortable: true },
      ],
      search: "",
      id: "",
      operador: "",
      fechaHoraActual: "",
      numeroAsistencia: "",
      comDireccionSiniestro: "",
      tipoServicio: "",
      inicioVigencia: "",
      proveedor: "",
      atiende: "",
      fechaHoraAsignacion: "",
      fechaHoraContacto: "",
      fechaHoraCierreAsistencia: "",
      obsAdicionales: "",
      disabled: false,
      seguimiento: "",
      cadena: "",
      separado: [],
      dataSplit: [],
      overlay: true,
      snackError: false,
      dateToday: "",
      idUsuario: "",
      idCabina: "",
      fechaDesde: null,
      fechaHasta: null,
      snackFechas: false,
      disabledActualizarBitacora: true,
      caracteresDisponibles: 0,
    };
  },
  computed: {
    formTitle() {
      return "Actualizar";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let me = this;
      var dateFormat = new Date();
      me.dateToday =
        dateFormat.getFullYear() +
        "-" +
        (dateFormat.getMonth() + 1) +
        "-" +
        dateFormat.getDate();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.bitacoras = [];
      me.overlay = true;
      axios
        .get(
          "api/Bitacoras/Listar/" + me.dateToday + "/" + me.dateToday,
          configuracion
        )
        .then(function(response) {
          me.bitacoras = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (me.fechaDesde != null && me.fechaHasta != null) {
        me.bitacoras = [];
        me.overlay = true;
        axios
          .get(
            "api/Bitacoras/Listar/" + me.fechaDesde + "/" + me.fechaHasta,
            configuracion
          )
          .then(function(response) {
            me.bitacoras = [];
            me.bitacoras = response.data;
            me.overlay = false;
          })
          .catch(function(error) {
            console.log("ERROR ", error);
            me.overlay = false;
          });
      } else {
        me.snackFechas = true;
      }
    },
    //Metodo que muestra cada campo y al dato "seguimiento" lo separa por "~" pra luego mostrarlo en cada campo se seguimiento solo si hay algo en el.
    editItem(item) {
      this.cadena = item.seguimiento;
      //console.log(this.cadena.length);
      this.counterSeguimiento = this.cadena.length;
      if (this.cadena != null && this.cadena != "") {
        this.separado = this.cadena.split("~");
        this.separado.forEach((element, index) => {
          this.caracteresDisponibles =
            this.caracteresDisponibles + element.length;
          this.dataSplit.push({
            seguimiento: element + "~",
            disabled: false,
          });
        });
      }
      this.id = item.idBitacora;
      this.idUsuario = item.idUsuario;
      this.idCabina = item.idCabina;
      this.operador = item.operador;
      this.numeroAsistencia = item.numeroAsistencia;
      this.fechaHoraActual = item.fechaHoraActual;
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.tipoServicio = item.tipoServicio;
      this.proveedor = item.proveedor;
      this.atiende = item.atiende;
      this.fechaHoraAsignacion = item.fechaHoraAsignacion;
      this.fechaHoraContacto = item.fechaHoraContacto;
      this.fechaHoraCierreAsistencia = item.fechaHoraCierreAsistencia;
      this.obsAdicionales = item.obsAdicionales;
      this.dialog = true;
      //FOR para deshabilitar solamente los campos que contienen comentarios
      for (var j = 0; j < this.dataSplit.length; j++) {
        if (this.dataSplit[j].seguimiento != "") {
          this.dataSplit[j].disabled = true;
        }
      }
    },
    close() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.idBitacora = "";
      this.idCabina = "";
      this.idUsuario = "";
      this.operador = "";
      this.fechaHoraActual = "";
      this.numeroAsistencia = "";
      this.comDireccionSiniestro = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.atiende = "";
      this.fechaHoraAsignacion = "";
      this.fechaHoraContacto = "";
      this.fechaHoraCierreAsistencia = "";
      this.obsAdicionales = "";
      this.seguimiento = "";
      this.disabled = false;
      this.cadena = "";
      this.separado = [];
      this.dataSplit = [];
      this.caracteresDisponibles = 0;
    },
    //Este metodo concatena cada comentario a la variable "seguimiento" solo si hay algo escrito en cada campo.
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let a1 = "";
      for (var i = 0; i < this.dataSplit.length; i++) {
        a1 = a1 + this.dataSplit[i].seguimiento;
      }
      axios
        .put(
          "api/Bitacoras/Actualizar",
          {
            idBitacora: me.id,
            idCabina: me.idCabina,
            idUsuario: me.idUsuario,
            operador: me.operador,
            fechaHoraActual: me.fechaHoraActual,
            comDireccionSiniestro: me.comDireccionSiniestro,
            tipoServicio: me.tipoServicio,
            proveedor: me.proveedor,
            atiende: me.atiende,
            fechaHoraAsignacion: me.fechaHoraAsignacion,
            seguimiento: a1,
            fechaHoraContacto: me.fechaHoraContacto,
            fechaHoraCierreAsistencia: me.fechaHoraCierreAsistencia,
            obsAdicionales: me.obsAdicionales,
          },
          configuracion
        )
        .then(function(response) {
          me.close();
          me.init();
        })
        .catch(function(error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    //Metodos que agregan fecha y el nombre de quien coloco el seguimiento.
    asignarfecha(i) {
      let me = this;
      var hora = new Date().getHours() + ":" + new Date().getMinutes();
      this.seguimiento =
        this.seguimiento +
        "" +
        new Date().toISOString().substr(0, 10) +
        " " +
        hora +
        " " +
        me.$store.state.usuario.nombre;
      this.dataSplit[i].seguimiento =
        this.dataSplit[i].seguimiento + this.seguimiento;
      this.disabledActualizarBitacora = false;
    },
    agregarCampo() {
      this.dataSplit.push({
        seguimiento: null,
      });
    },
  },
};
</script>
